
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { User } from "lucide-react";
import React from "react";

interface UsernameInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  checking: boolean;
  available: boolean | null;
}

const UsernameInput: React.FC<UsernameInputProps> = ({
  value,
  onChange,
  error,
  checking,
  available,
}) => (
  <div className="space-y-2">
    <Label htmlFor="username">Username</Label>
    <div className="relative">
      <User className="absolute left-3 top-1/2 transform -translate-y-1/2 text-black h-4 w-4" />
      <Input
        id="username"
        type="text"
        value={value}
        onChange={onChange}
        className="pl-10"
        placeholder="Choose a username"
        required
        autoComplete="off"
      />
      {checking && (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xs text-black">Checking…</span>
      )}
      {value.length >= 3 && available === true && !error && (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xs text-green-600">Available</span>
      )}
      {value.length >= 3 && available === false && (
        <span className="absolute right-3 top-1/2 transform -translate-y-1/2 text-xs text-red-500">Taken</span>
      )}
      {error && (
        <div className="text-sm text-red-500 ml-1 mt-1">{error}</div>
      )}
    </div>
  </div>
);

export default UsernameInput;
